var _rect, _polygon, _path, _polygon2, _rect2, _rect3, _rect4, _rect5, _polygon3, _path2, _path3, _path4, _rect6, _rect7, _rect8, _polygon4, _polygon5, _polygon6, _path5, _circle, _rect9, _path6, _circle2, _rect0, _path7, _circle3, _rect1, _path8, _circle4, _rect10, _path9, _circle5, _rect11, _path0, _polygon7, _polygon8, _path1, _path10, _path11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4780d57-a0d1-40af-9ba7-f5dc06614a85",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 875.94535,
    height: 489.68816,
    viewBox: "0 0 875.94535 489.68816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "small_town") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 801.4278,
    y: 294.79667,
    width: 21.73327,
    height: 75.23054,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "837.973 358.996 783.874 293.961 678.551 293.961 614.187 356.653 615.488 357.489 615.023 357.489 615.023 487.888 837.371 487.888 837.371 357.489 837.973 358.996",
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959.25986,475.31344c-.00213.09473-.00717.18869-.00717.28388a63.23483,63.23483,0,0,0,4.60779,10.57182,26.34289,26.34289,0,0,0-1.34624,8.45387c0,9.90717,5.11077,17.93851,11.41541,17.93851s11.41542-8.03134,11.41542-17.93851a27.15242,27.15242,0,0,0-.744-6.37227,13.03567,13.03567,0,0,0,1.40384-15.87725,13.04435,13.04435,0,1,0,16.90468-19.86792,13.04738,13.04738,0,1,0-17.56453-12.24168c0,.191.00637.38052.01433.5695a13.05459,13.05459,0,0,0-16.71755,10.50647,13.04643,13.04643,0,1,0-9.382,23.97358Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e2e2e2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "784.71 293.125 718.674 370.545 718.674 487.888 837.371 487.888 837.371 355.817 784.71 293.125",
    fill: "#11cdef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 766.32021,
    y: 422.99564,
    width: 24.24097,
    height: 21.42621,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 766.32021,
    y: 385.90921,
    width: 24.24097,
    height: 21.08643,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 766.32021,
    y: 422.99564,
    width: 24.24097,
    height: 21.42621,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 766.32021,
    y: 385.90921,
    width: 24.24097,
    height: 21.08643,
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "487.973 254.996 392.098 140.816 203.602 140.816 88.41 253.016 90.737 254.512 89.905 254.512 89.905 487.888 487.842 487.888 487.842 254.512 487.973 254.996",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M533.38081,215.649l12.93827-10.34815c-10.05116-1.10891-14.181,4.37278-15.87118,8.71159-7.85238-3.26061-16.40064,1.01258-16.40064,1.01258l25.8871,9.39793A19.58939,19.58939,0,0,0,533.38081,215.649Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M765.53827,243.19563l12.93827-10.34815c-10.05117-1.10891-14.181,4.37278-15.87119,8.71159-7.85238-3.26061-16.40063,1.01258-16.40063,1.01258l25.88709,9.39793A19.58937,19.58937,0,0,0,765.53827,243.19563Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M710.05073,322.02207,722.989,311.67392c-10.05117-1.10892-14.181,4.37277-15.87118,8.71158-7.85239-3.2606-16.40064,1.01258-16.40064,1.01258l25.8871,9.39793A19.58935,19.58935,0,0,0,710.05073,322.02207Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 408.55722,
    y: 130.12538,
    width: 21.73327,
    height: 75.23054,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 628.39757,
    y: 219.56613,
    width: 21.73327,
    height: 75.23054,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 628.39757,
    y: 212.04308,
    width: 21.73327,
    height: 75.23054,
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "682.973 307.996 608.788 219.885 463.235 219.885 374.286 306.524 376.082 307.679 375.441 307.679 375.441 487.888 682.72 487.888 682.72 307.679 682.973 307.996",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "609.943 218.73 518.684 325.722 518.684 487.888 682.72 487.888 682.72 305.369 609.943 218.73",
    fill: "#11cdef"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "393.594 139.32 275.41 277.878 275.41 487.888 487.842 487.888 487.842 251.52 393.594 139.32",
    fill: "#11cdef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M341.80568,689.22081s.51967-10.889,11.17292-9.62329",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.76823,
    cy: 468.37079,
    r: 5.33187,
    fill: "#11cdef"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 175.90066,
    y: 477.34935,
    width: 1.50506,
    height: 10.53543,
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M389.45169,689.22081s.51967-10.889,11.17291-9.62329",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.41424,
    cy: 468.37079,
    r: 5.33187,
    fill: "#11cdef"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 223.54667,
    y: 477.34935,
    width: 1.50506,
    height: 10.53543,
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M662.78931,689.22081s.51967-10.889,11.17291-9.62329",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 497.75186,
    cy: 468.37079,
    r: 5.33187,
    fill: "#11cdef"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 496.88428,
    y: 477.34935,
    width: 1.50506,
    height: 10.53543,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M864.24,689.22081s.51967-10.889,11.17292-9.62329",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.20252,
    cy: 468.37079,
    r: 5.33187,
    fill: "#11cdef"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 698.33495,
    y: 477.34935,
    width: 1.50506,
    height: 10.53543,
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.60588,689.22081s.51967-10.889,11.17292-9.62329",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.56843,
    cy: 468.37079,
    r: 5.33187,
    fill: "#11cdef"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 110.70086,
    y: 477.34935,
    width: 1.50506,
    height: 10.53543,
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M785.8475,386.00507c-.00243.10852-.00821.21616-.00821.3252a14.89777,14.89777,0,0,0,4.53151,10.715,14.93059,14.93059,0,0,0,.74709,1.3959,30.17816,30.17816,0,0,0-1.54222,9.68461c0,11.3495,5.85481,20.55007,13.07731,20.55007s13.07732-9.20057,13.07732-20.55007a31.10512,31.10512,0,0,0-.8523-7.3,14.93347,14.93347,0,0,0,1.60821-18.18873,14.9434,14.9434,0,1,0,19.36573-22.76037,14.94688,14.94688,0,1,0-20.12164-14.02388c0,.21881.0073.43592.01642.65241a14.95513,14.95513,0,0,0-19.15136,12.036,14.94578,14.94578,0,1,0-10.74786,27.46376Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e2e2e2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "169.073 240.854 150.36 266.745 148.55 215.396 146.312 291.211 129.067 267.351 146.157 296.451 140.497 488.161 158.162 488.161 150.558 272.379 169.073 240.854",
    fill: "#e2e2e2"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.073 164.137 60.555 198.059 58.184 130.781 55.251 230.115 32.657 198.854 55.049 236.98 47.633 488.161 70.777 488.161 60.815 205.441 85.073 164.137",
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1037.97267,694.84408H162.02733V290.64822h875.94534ZM165.405,691.4664h869.19V294.0259H165.405Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M930.21265,214.45905a72.18843,72.18843,0,0,0-13.5,1.28443,71.86054,71.86054,0,0,1,0,141.16449,71.86438,71.86438,0,1,0,13.5-142.44892Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e2e2e2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M562.25017,294.031c-.00285.12737-.00964.25371-.00964.38171a17.48647,17.48647,0,0,0,5.31894,12.57692,17.52184,17.52184,0,0,0,.87691,1.63845,35.42187,35.42187,0,0,0-1.81022,11.36746c0,13.32164,6.87218,24.121,15.3497,24.121s15.3497-10.79932,15.3497-24.121a36.51043,36.51043,0,0,0-1.0004-8.56845,17.52841,17.52841,0,0,0,1.88767-21.34929,17.54,17.54,0,1,0,22.73082-26.71533,17.54412,17.54412,0,1,0-23.61809-16.46074c0,.25684.00857.51167.01928.76578a17.55381,17.55381,0,0,0-22.47921,14.12749,17.54284,17.54284,0,1,0-12.61546,32.236Z",
    transform: "translate(-162.02733 -205.15592)",
    fill: "#e2e2e2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 302.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 302.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 302.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 302.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 362.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 362.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 362.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 362.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#fff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 422.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 422.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 422.72115,
    y: 305.37631,
    width: 43.38403,
    height: 44.35999,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 422.72115,
    y: 365.7363,
    width: 43.38403,
    height: 44.36005,
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 561.40627,
    y: 395.38724,
    width: 33.50037,
    height: 32.43152,
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 561.40627,
    y: 346.95578,
    width: 33.50037,
    height: 32.43146,
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 561.40627,
    y: 395.38724,
    width: 33.50037,
    height: 32.43152,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 561.40627,
    y: 346.95578,
    width: 33.50037,
    height: 32.43146,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 610.40627,
    y: 395.38724,
    width: 33.50037,
    height: 32.43152,
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 610.40627,
    y: 346.95578,
    width: 33.50037,
    height: 32.43146,
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 610.40627,
    y: 395.38724,
    width: 33.50037,
    height: 32.43152,
    fill: "#fff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 610.40627,
    y: 346.95578,
    width: 33.50037,
    height: 32.43146,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.b8c526adec76c5e123426a84d1c31ecf.svg";
export { ForwardRef as ReactComponent };